module.exports = __webpack_public_path__ + "components/app-promo/static/logo-intersport-fdda1c5b05a4488b061b7e540d8e9de8.svg";